import { Injectable } from '@angular/core';

import { AppService } from './app.service';
import { HttpParams, HttpClient } from '@angular/common/http';
//import { AccountService } from './account.service';

@Injectable()
export class FileuploadService {
  api:any;
  apiUrl:any;
  basePath = '';

  constructor(private as: AppService, private http: HttpClient) { 
    this.api = as.getApi();
    this.apiUrl = as.getApiUrl();
    
  }

  
  setPath(path){
    this.basePath = '/uploads/'+path;
  }

  setPrivatePath(path){
    this.basePath = '/private_uploads/'+path;
  }

  pushUpload(file,filename,auditory = null) {
    
    let mid = this.as.getMachineId();
    if(this.as.isConnected()){    
      
      let connect_data = this.as.getConnectData();
      let response:any;

      let params = new HttpParams();
    
      let api = this.api.snapshot;
      let body = {
        token:connect_data.token,
        screen_id:connect_data.screen_id,
        session_id:mid,
        file:file,
        file_name:filename,
        base_path:this.basePath,
        ad_id:null,
        account_id:null,
        
      }
      if(auditory != null){
        params = params.append('ad_id',auditory);
        api = this.api.ad_snapshot;
        body.ad_id = auditory.id;
        body.account_id = auditory.account_id;
      }
      

      this.http.post(this.apiUrl+api,body).subscribe(s=>{
        
      },(e)=>{
        console.log("ERRR:"+e);
      });
      
    }
  }

  // Writes the file details to the realtime db
  //private saveFileData(upload: Upload) {
    //this.db.collection(`${this.basePath}/`).add(upload);
 // }


}



export class Upload{
  file: any;
  name: string;
  url: string;
  progress: number;
  createdAt: Date = new Date();

  constructor(file:File){
      this.file = file;
  }

}


// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/services/fileupload.service.ts